<template>
  <div class="edition-info">
    <h4>
      <Chevron
        @expand="expanded = !expanded"
        :expanded="expanded"
      />
      {{ $t('editionInfoMetadata.title') }}
    </h4>
    <dl v-if="expanded">
        <dt v-if="editor">{{ $t('editor') }}</dt>
        <dd v-if="editor">{{ editor }}</dd>
        <dt v-if="isbn">{{ $t('isbnEditionInfo') }}</dt>
        <dd v-if="isbn">{{ isbn }}</dd>
        <dt v-if="publisher">{{ $t('publisher') }}</dt>
        <dd v-if="publisher">{{ publisher }}</dd>
        <dt v-if="volume">{{ $t('volumeEditionInfo') }}</dt>
        <dd v-if="volume">{{ volume }}</dd>
        <dt v-if="year">{{ $t('yearEditionInfo') }}</dt>
        <dd v-if="year">{{ year }}</dd>
    </dl>
    <p v-if="expanded && !hasMetadataValues">
      {{ $t('editionInfoMetadata.noInfo') }}
    </p>
    <router-link v-if="expanded" class="about-editions-link" :to="{ name: 'about-editions' }">{{ $t('editionsDisclaimer.title') }}</router-link>
  </div>
</template>

<script>
  import Chevron from './Chevron.vue';
  import { WORK_METADATA_KEY_LOOKUP } from '../constants';

  export default {
    components: { Chevron },
    props: ['work'],
    data() {
      return {
        expanded: false,
      };
    },
    computed: {
      metadata() {
        const workKey = WORK_METADATA_KEY_LOOKUP[this.work.urn];
        return this.$i18n.getLocaleMessage(this.$i18n.locale)[workKey].bibliography;
      },
      hasMetadataValues() {
        const metadataValues = Object.values(this.metadata).filter(x => x !== '');
        return metadataValues.length > 0;
      },
      editor() {
        return this.metadata.editor;
      },
      isbn() {
        return this.metadata.isbn;
      },
      publisher() {
        return this.metadata.publisher;
      },
      volume() {
        return this.metadata.volume;
      },
      year() {
        return this.metadata.year;
      },
    },
  };
</script>

<style lang="scss" scoped>
  @import '../variables';
  #app[data-locale="ar"] .edition-info {
    direction: rtl;
    h4 {
      letter-spacing: normal;
      font-size: 32px;
      line-height: 40px;
      font-family: $ar-font-family;
    }
    a {
     font-size: $ar-text-sm;
     font-family: $ar-font-family;
    }
  }
  .edition-info {
    background: $gray-100;
    border: 1px solid $gray-200;
    padding: 10px 15px;

    h4 {
      margin: 0;
      padding: 0;
      text-transform: uppercase;
      letter-spacing: .2em;
      font-size: 16px;
      line-height: 24px;
      font-weight: 400;
      color: $gray-600;
      > svg {
        margin-top: auto;
        margin-bottom: auto;
      }
    }
    margin-bottom: 10px;
  }
  dt {
    font-size: 14px;
    letter-spacing: 2px;
    text-transform: uppercase;
    color: $gray-600;
  }
  dd {
    margin: 0.5em 0 1.0em;
    font-size: 14px;
  }
  #app[data-locale="ar"] dl {
    direction: rtl;
    dt {
      letter-spacing: normal;
      font-size: $ar-text-lg;
      font-family: $ar-font-family;
    }
    dd {
      font-size: $ar-text-md;
      direction: rtl;
      font-family: $ar-font-family;
    }
  }
  .about-editions-link {
    margin-bottom: 3.0rem;
    font-size: 0.8em;
    color: $gray-800;
    display: block;
    &:hover {
      color: $gray-600;
    }
  }
</style>
